import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Button } from "reactstrap"

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: this.props.subscription.date ? this.props.subscription.date : new Date()
        };
    }

    handleChange = date => {
        let modifiedDate = new Date(new Date(date).setHours(7));
        this.setState({
            startDate: modifiedDate
        });
        this.props.subscription.date = modifiedDate;
    };

    render() {
        let email = this.props.subscription.emailSubscription;
        let phone = this.props.subscription.phoneSubscription;
        return (
            <>
                <Row>
                    <Col>
                        <p className="notificationText">Select your court date to receive notifications as your court date approaches</p>
                        <DatePicker
                            className="datepicker"
                            selected={this.state.startDate}
                            onChange={this.handleChange}
                        />
                    </Col>
                </Row>
                <br />
                <p className="notificationText">How do you want to receive notifications?</p>
                <Row>
                    <Col>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <Input addon type="checkbox" aria-label="Use email notifications" defaultChecked={email.isSubscribed} onChange={e => {
                                        email.isSubscribed = !email.isSubscribed;
                                    }} />
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder={email.email ? email.email : "Email: example@gmail.com"} type="email" onChange={e => {
                                email.email = e.target.value;
                            }} />
                        </InputGroup>
                        <br />
                        <p className="ratesMayApplyText">Standard messaging rates may apply</p>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                    <Input addon type="checkbox" aria-label="Use telephone notifications" defaultChecked={phone.isSubscribed} onChange={e => {
                                        phone.isSubscribed = !phone.isSubscribed;
                                    }} />
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder={phone.phone ? phone.phone : "Text: 541-218-6384"} type="tel" onChange={e => {
                                phone.phone = e.target.value;
                            }} />
                        </InputGroup>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col xs="8" />
                    <Col xs="4">
                        <Button color="primary" onClick={() => {
                            this.props.updateNotifications();
                        }}>Submit</Button>
                    </Col>
                </Row>
            </>
        );
    }
}

export default App;